import React from 'react';
import { observer } from '../../shared/observer';
import { OrderCard } from './OrderCard';

// Экран «Заказы» ЛК: сверху активные (waiting_approve / warehouse /
// waiting_delivery — как current_orders на сервере и в приложении),
// ниже — история. Карточка и все действия — в OrderCard.
class OrdersView extends React.Component {
  componentDidMount() {
    // Ошибка уже записана в стор (ordersError) и рисуется в render.
    this.props.order.ensureOrders().catch(() => {});
  }

  reload = () => this.props.order.getOrders();

  renderGroup(title, list, active) {
    if (!list.length) return null;
    return (
      <section className="ng-order-group">
        {title && <h2 className="ng-order-group__title">{title}</h2>}
        <div className="ng-order-list">
          {list.map((o) => (
            <OrderCard key={o.id} item={o} active={active} onChanged={this.reload} />
          ))}
        </div>
      </section>
    );
  }

  render() {
    const store = this.props.order;
    const list = store.orders || [];
    const error = store.ordersError;

    if (store.ordersLoading || (!store.ordersLoaded && !error)) {
      return (
        <div>
          <h1>Заказы</h1>
          <div className="ng-order-list">
            {[0, 1, 2].map((i) => (
              <article key={i} className="ng-order">
                <span className="ng-skel ng-skel--block" style={{ height: 16 }} />
              </article>
            ))}
          </div>
        </div>
      );
    }

    if (!list.length) {
      return (
        <div>
          <h1>Заказы</h1>
          {error ? (
            <div className="order-message">{error}</div>
          ) : (
            <p className="ng-checkout__hint">У вас пока нет заказов.</p>
          )}
          <a className="btn" href="/catalog">В каталог</a>
        </div>
      );
    }

    const active = store.activeOrders;
    const past = store.pastOrders;
    // Заголовки нужны, только когда обе группы непусты: иначе это просто
    // список заказов под общим h1.
    const bothGroups = !!active.length && !!past.length;

    return (
      <div>
        <h1>Заказы</h1>
        {error && <div className="order-message">{error}</div>}
        {this.renderGroup(bothGroups ? 'Активные заказы' : null, active, true)}
        {this.renderGroup(bothGroups ? 'История заказов' : null, past, false)}
      </div>
    );
  }
}

export const Orders = observer(OrdersView, ['orderStore', 'authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Profile/Orders.jsx